import { useTranslation } from 'react-i18next';

import { env, isProduction } from '../config/env';
import styles from './PlaceholderPage.module.css';

export default function PlaceholderPage() {
  const { t } = useTranslation();
  const messages = [
    t('placeholder.message1'),
    t('placeholder.message2'),
    t('placeholder.message3'),
  ];

  return (
    <main className={styles.page}>
      <header className={styles.hero}>
        <h1 className={styles.title}>{t('placeholder.title')}</h1>
        <p className={styles.tagline}>{t('placeholder.tagline')}</p>
      </header>

      <section className={styles.chat} aria-label={t('placeholder.narrator')}>
        <div className={styles.chatHeader}>
          <span className={styles.avatar} aria-hidden="true">
            MC
          </span>
          <div>
            <p className={styles.narrator}>{t('placeholder.narrator')}</p>
            <p className={styles.status}>
              <span className={styles.statusDot} aria-hidden="true" />
              {t('placeholder.status')}
            </p>
          </div>
        </div>

        <ol className={styles.messages}>
          {messages.map((message, index) => (
            <li
              key={message}
              className={styles.bubble}
              style={{ animationDelay: `${index * 0.6}s` }}
            >
              {message}
            </li>
          ))}
          <li className={styles.typing} aria-label={t('placeholder.typing')}>
            <span />
            <span />
            <span />
          </li>
        </ol>
      </section>

      {!isProduction && (
        <footer className={styles.build}>
          {env.appEnv}
          {env.commitSha && ` · ${env.commitSha.slice(0, 7)}`}
        </footer>
      )}
    </main>
  );
}
